module.exports = function() {

  return {
    template: require('html/templates/routeName'),
    restrict: 'E',
    replace: true,
    link: function(scope, element, attrs) {
      if (attrs.routeId) {
        scope.route = scope.routePlan.findRoute(+attrs.routeId);
      }
    }
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/routeName.js
 ** module id = 155
 ** module chunks = 1
 **/